import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Loading} from '../lib/index';
import API from '../api';
import OptionsStep from "./OptionsStep";
import Button from "../lib/components/Button";
import dateFormat from "dateformat";
import {dateFormatsLocations} from "../constants/dateFormatsLocations";


class ChooseApp extends Component {

    constructor(props) {
        super(props);
        let index = +props.showItems;
        let loadMoreCondition = props.step.metadata.options.length <= index;
        let options = loadMoreCondition ?  props.step.metadata.options :  props.step.metadata.options.slice(0, index);

        this.state = {
            loading: false,
            trigger: false,
            loadMoreButtonShow: !loadMoreCondition,
            options: options
        };

        this.handleMoreOptions = this.handleMoreOptions.bind(this);

    }

    handleMoreOptions() {

       let options = this.props.step.metadata.options;
       this.setState({options: options,loadMoreButtonShow:false});
    }


    render() {
        const {loading, options,loadMoreButtonShow} = this.state;
        const {step, store} = this.props;
        const {texts} = store.settings;
        return (
            <div>
                {loading ? (
                    <Loading/>
                ) : (
                   <div> <OptionsStep
                        options={options}
                        step={step}
                        speak={false}
                        triggerNextStep={this.props.triggerNextStep}
                    />  {loadMoreButtonShow ? (
                       <Button onClick={() => this.handleMoreOptions()}>
                           {texts.loadMore}
                       </Button>
                   ) : ('')}
                    </div>
                )}
            </div>
        );
    }
}

ChooseApp.propTypes = {
    steps: PropTypes.object,
    triggerNextStep: PropTypes.func,
};

ChooseApp.defaultProps = {
    steps: undefined,
    triggerNextStep: undefined,
};


export default ChooseApp;
